// File: frontend/src/utils/axios.js

import axios from 'axios';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  return 'https://api.grovvia.site';
};

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path.replace('/api/uploads/', '/uploads/');
  }
  const baseUrl = getBaseURL().replace(/\/api\/?$/, '').replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 120000, // 2 minutes timeout for AI generation & OCR tasks
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach JWT authorization token to header
api.interceptors.request.use(
  async (config) => {
    try {
      // Get authentication token from local storage
      const token = localStorage.getItem('token');
      
      // If token exists, attach Bearer token to Authorization header
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // If payload is FormData, remove static Content-Type so browser sets boundary header
      if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
      }
      return config;
    } catch (error) {
      // Handle error in request interceptor
      return Promise.reject(error);
    }
  },
  (error) => {
    // Handle error before sending request
    return Promise.reject(error);
  }
);

// Response interceptor to handle unauthorized errors globally
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      // If 401 unauthorized response received, clear token and state and redirect to login
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    } catch (err) {
      console.error('Error handling response interceptor:', err);
    }
    return Promise.reject(error);
  }
);

export default api;
